import React from "react";
import NeuarpulseLogo from "src/assets/images/neurapulse/neurapulse-logo-icon-blue.png";
import { Icon } from "src/components/icons/Icon";
import { Copy } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import { toast } from "react-toastify";

interface IProps {
	neurapulseRef?: React.Ref<HTMLDivElement>;
	magicLink: string;
	toast: typeof toast;
}

export const NeurapulseLink: React.FC<IProps> = ({
	magicLink,
	toast,
	neurapulseRef,
}) => {
	return (
		<div
			ref={neurapulseRef}
			className="mt-2 d-flex"
			style={{
				border: "1px solid #ccc",
				borderRadius: "15px",
				paddingTop: "15px",
				paddingLeft: "15px",
				paddingRight: "15px",
				paddingBottom: "10px",
				marginBottom: "25px",
			}}
		>
			<div>
				<QRCodeCanvas value={magicLink} size={100} />
			</div>
			<div style={{ margin: "0 0 0 20px", width: "100%" }}>
				<div>
					<div className="d-flex align-items-center">
						<img
							src={NeuarpulseLogo}
							alt="Neurapulse Logo"
							style={{ width: "24px", height: "auto", paddingRight: "5px" }}
						/>
						<h5 className="mb-0">Neurapulse</h5>
					</div>
					<p>
						Neurapulse link created. Copy and paste the link below to share with
						the participant:
					</p>
				</div>
				<div className="d-flex flex-row">
					<input
						type="text"
						className="ant-input"
						value={magicLink}
						readOnly
						style={{ width: "85%" }}
						onFocus={(e) => e.target.select()}
					/>
					<button
						className="mr-auto btn-primary"
						style={{ width: "15%", marginLeft: "10px" }}
						onClick={() => {
							navigator.clipboard.writeText(magicLink);
							toast.success("Neurapulse link copied to clipboard");
						}}
					>
						<Icon icon={Copy} /> Copy
					</button>
				</div>
			</div>
		</div>
	);
};
